import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer
} from 'recharts';

export default function BarChartView({ data, onBarClick }) {
  if (!data || data.length === 0) return null;

  const CustomBar = (props) => {
    const { x, y, width, height, payload } = props;

    return (
      <g onClick={() => onBarClick?.(payload.details)} style={{ cursor: 'pointer' }}>
        <rect x={x} y={0} width={width} height={300} fill="transparent" />
        <rect x={x} y={y} width={width} height={height} fill="#57b950" />
      </g>
    );
  };

  return (
    <div className="bar-chart-container">
      <ResponsiveContainer>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="filename" tick={{ fill: '#ffffff' }} />
          <YAxis domain={[0, 100]} tick={{ fill: '#ffffff' }} tickFormatter={(t) => `${t}%`} />
          <Tooltip
            formatter={(val) => `${val}%`}
            contentStyle={{ backgroundColor: '#333' }}
            itemStyle={{ color: '#ffffff' }}
            labelStyle={{ color: '#ffffff' }}
          />
          <Bar
            dataKey="similarity"
            shape={<CustomBar />}
            isAnimationActive={false}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
